import React, { useState } from "react";

const plans = [
  {
    id: "platinum",
    title: "Platinum",
    price: "From €144,99/month*",
    features: [
      "Maximum and most exclusive performance for profitable growth.",
      "Highest organic visibility",
      "All demand tools",
      "Up to 5 free allowances",
      "Direct Offer",
      "Premium Customer Service",
      "Listings Service AI",
      "Social+",
    ],
  },
  {
    id: "gold",
    title: "Gold",
    badge: "BESTE WAHL",
    price: "From €94,99/month*",
    features: [
      "Stand out from the competition with precision and confidence.",
      "High organic visibility",
      "All demand tools",
      "Up to 3 free allowances",
      "Direct Offer",
      "Premium Customer Service",
    ],
  },
  {
    id: "silver",
    title: "Silver",
    price: "From €59,99/month*",
    features: [
      "Easily and efficiently increase sales opportunities.",
      "Increased organic visibility",
      "All demand tools",
      "Free allowances",
      "Direct Offer",
    ],
  },
  {
    id: "bronze",
    title: "Bronze",
    price: "From €42,99/month*",
    features: [
      "Benefit directly from a large reach.",
      "Normal organic visibility",
      "Individual demand tools",
    ],
  },
];

const PricingGrid = () => {
  const [activePlan, setActivePlan] = useState("gold");

  const selectedPlan = plans.find((p) => p.id === activePlan);

  if (!selectedPlan) return null;

  return (
    <div className="pricing__grid gap_m">
      <div
        className="pricing-card pricing-card--active"
        role="button"
        tabIndex={0}
      >
        {selectedPlan.badge && (
          <span className="pricing-card__badge">
            {selectedPlan.badge}
          </span>
        )}

        <div className="pricing-card__header">
          <span className="radio" />
          <h3>{selectedPlan.title}</h3>
        </div>

        <ul className="pricing-card__features">
          {selectedPlan.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>

        <div className="pricing-card__price">
          {selectedPlan.price}
        </div>
      </div>
    </div>
  );
};

export default PricingGrid;
